<template>
    <div v-loading="loading">
        <EnterNewEmailAddress @showConfirm="showConfirm" ref="enterNewEmailAddress"></EnterNewEmailAddress>
        <ConfirmSendEmail ref="confirmSendEmail"></ConfirmSendEmail>
    </div>

</template>

<script>
    import ConfirmSendEmail from "./components/ConfirmSendEmail";
    import EnterNewEmailAddress from "./components/EnterNewEmailAddress";

    export default {
        name: "ChangeEmail",
        components: {
            EnterNewEmailAddress,
            ConfirmSendEmail
        },

        data() {
            return {
                loading: false,
            }

        },

        created() {
        },

        methods: {
            showConfirm(changedEmail) {
                this.$refs['enterNewEmailAddress'].disabled = true;
                this.$refs['confirmSendEmail'].disabled = false;
                this.$refs['confirmSendEmail'].changedEmail = changedEmail;
            }
        }
    }
</script>

<style scoped lang="scss">
    #back_button:hover{
        background-color: white;

    }

    @media only screen and (max-width: 450px){

    }

</style>